import { classNames, useRef, useState } from 'libs/react';
import { Button } from 'components/Button';
import { Text } from 'components/Text';
import { Form } from 'components/form/Form';
import { FormAction } from 'components/form/FormAction';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormInput } from 'components/form/FormInput';
import { React } from 'libs/react';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { Icon } from 'components/Icon';
import './DealSummaryPanelDiscount.scss';
/**
 * @component DealSummaryPanelDiscount
 * @since 1.0.0
 */
export function DealSummaryPanelDiscount(props) {
    var _a, _b;
    const { style, deal, editable } = Object.assign({ style: 'normal' }, props);
    const { updateDealField } = useDealConfiguratorContext();
    const [userInputPercent, setUserInputPercent] = useState((deal === null || deal === void 0 ? void 0 : deal.discountType) === 'PERCENTAGE');
    const [userInputDollar, setUserInputDollar] = useState((deal === null || deal === void 0 ? void 0 : deal.discountType) === 'AMOUNT');
    const percentRef = useRef(null);
    const dollarRef = useRef(null);
    const [discount, setDiscount] = useState((_a = deal === null || deal === void 0 ? void 0 : deal.discount) !== null && _a !== void 0 ? _a : 0);
    const [discountType, setDiscountType] = useState((_b = deal === null || deal === void 0 ? void 0 : deal.discountType) !== null && _b !== void 0 ? _b : 'PERCENTAGE');
    /**
     * @function onApplyDiscount
     * @since 1.0.0
     * @hidden
     */
    function onApplyDiscount() {
        if (isNaN(discount)) {
            setDiscount(0);
        }
        updateDealField('discount', discount.toString(), 'number');
        updateDealField('discountType', discountType, 'string');
    }
    /**
     * @function onDiscountPercentChange
     * @since 1.0.0
     * @hidden
     */
    const onDiscountPercentChange = (value) => {
        const discount = parseFloat(value);
        setDiscount(discount > 100 ? 100 : discount);
        setDiscountType('PERCENTAGE');
    };
    /**
     * @function onDiscountDollarChange
     * @since 1.0.0
     * @hidden
     */
    const onDiscountDollarChange = (value) => {
        setDiscount(parseFloat(value));
        setDiscountType('AMOUNT');
    };
    /**
     * @function onPercentClick
     * @since 1.0.0
     * @hidden
     */
    const onPercentClick = () => {
        var _a;
        setUserInputPercent(true);
        setUserInputDollar(false);
        (_a = percentRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    /**
     * @function onDollarClick
     * @since 1.0.0
     * @hidden
     */
    const onDollarClick = () => {
        var _a;
        setUserInputDollar(true);
        setUserInputPercent(false);
        (_a = dollarRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const className = classNames('deal-summary-panel-discount', 'deal-summary-panel-discount--' + style, props.className);
    // A store promo code sets the discount: the server recomputes it with the
    // cart, so it cannot be typed by hand.
    if (deal === null || deal === void 0 ? void 0 : deal.promoCode) {
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "deal-summary-panel-discount-title-container" },
                React.createElement(Text, { value: t('Discount'), className: "deal-summary-panel-discount-title" })),
            React.createElement("div", { className: "deal-summary-panel-discount-promo" },
                React.createElement(Icon, { value: "tag" }),
                React.createElement(Text, { value: `${t('Promo code')} ${deal.promoCode.code} : -${deal.promoCode.discountAmount.toFixed(2)} $` }))));
    }
    return (React.createElement("div", { className: className },
        React.createElement(Form, null,
            React.createElement("div", { className: "deal-summary-panel-discount-title-container" },
                React.createElement(Text, { value: t('Discount'), className: "deal-summary-panel-discount-title" }),
                React.createElement("div", { className: "deal-summary-panel-discount-title-tooltip" },
                    React.createElement(Icon, { className: "deal-summary-panel-discount-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-summary-panel-discount-title-tooltip-value", value: t('This discount will be applied to the subtotal amount of the quote.') }))),
            React.createElement(FormGroup, null,
                React.createElement(FormField, null,
                    React.createElement("div", { className: "deal-summary-panel-discount-input deal-summary-panel-discount-input--left", onClick: onPercentClick },
                        React.createElement(FormInput, { type: "number", prefix: "%", onChange: userInputPercent ? onDiscountPercentChange : undefined, value: discountType === 'PERCENTAGE' ? discount.toString() : '0', disabled: userInputPercent ? false : true, className: userInputPercent ? 'isActive' : '', ref: percentRef }),
                        React.createElement(Icon, { value: userInputPercent ? 'angle-left' : 'angle-right' })),
                    React.createElement("div", { className: "deal-summary-panel-discount-input deal-summary-panel-discount-input--right", onClick: onDollarClick },
                        React.createElement(FormInput, { type: "number", suffix: "$", onChange: userInputDollar ? onDiscountDollarChange : undefined, value: discountType === 'AMOUNT' ? discount.toString() : '0', disabled: userInputDollar ? false : true, className: userInputDollar ? 'isActive' : '', ref: dollarRef })))),
            editable && (React.createElement(FormAction, { align: "start" },
                React.createElement(Button, { style: "outline", label: t('Apply Discount'), onPress: onApplyDiscount }))))));
}
